import usePageEditorContext from '~/pages/pages/edit/context/hooks/use-page-editor-context';

const usePageEditorDispatch = () => {
  const { dispatch } = usePageEditorContext();

  return dispatch;
};

export default usePageEditorDispatch;
